import { render, staticRenderFns } from "./AddInstrumentMobileBtn.vue?vue&type=template&id=67537e73&"
import script from "./AddInstrumentMobileBtn.vue?vue&type=script&lang=js&"
export * from "./AddInstrumentMobileBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports